import { Image } from 'react-native';

import { Images } from '@vfgroup-oneplatform/foundation/Components/Themes';

const images = {
  ...Images,

  vfLogo: Image.resolveAssetSource(require('../Assets/Images/vfLogo@3x.png')),
  toBi: Image.resolveAssetSource(require('../Assets/Images/toBi@3x.png')),
  payment_visa: Image.resolveAssetSource(require('../Assets/Images/visa@3x.png')),
  payment_visa_pay: Image.resolveAssetSource(require('../Assets/Images/visaPay@3x.png')),
  minimize: Image.resolveAssetSource(require('../Assets/Images/minimize@3x.png')),
  icTutorial: Image.resolveAssetSource(require('../Assets/Images/icTutorial@3x.png')),
  ic_tick_solution: Image.resolveAssetSource(
    require('../Assets/Images/icTickSolutionShakefinderGreen@3x.png'),
  ),
  ic_sound_active_white: Image.resolveAssetSource(
    require('../Assets/Images/ic_sound_active_white@3x.png'),
  ),
  ic_sound_off: Image.resolveAssetSource(require('../Assets/Images/ic_sound_off@3x.png')),
  ic_pause_white: Image.resolveAssetSource(require('../Assets/Images/ic_pause_white@3x.png')),
  ic_play_arrow_white: Image.resolveAssetSource(
    require('../Assets/Images/ic_play_arrow_white@3x.png'),
  ),
  ic_sync_white: Image.resolveAssetSource(require('../Assets/Images/ic_sync_white@3x.png')),
  ic_slider_thumb: Image.resolveAssetSource(require('../Assets/Images/ic_slider_thumb@3x.png')),
  icCurrentLocation: Image.resolveAssetSource(require('../Assets/Images/icCurrentLocation@3x.png')),
  icCallsContactsWhite: Image.resolveAssetSource(
    require('../Assets/Images/icCallsContactsWhite@3x.png'),
  ),
  payment_method_card: Image.resolveAssetSource(require('../Assets/Images/cardBackground@3x.png')),
  payment_card_chip: Image.resolveAssetSource(require('../Assets/Images/cardChip@3x.png')),
  icNetwork: Image.resolveAssetSource(require('../Assets/Images/icNetwork@3x.png')),
  ic_list: Image.resolveAssetSource(require('./../Assets/Images/icList@3x.png')),
  ic_store: Image.resolveAssetSource(require('./../Assets/Images/icStore@3x.png')),
  icAccelerationMid: Image.resolveAssetSource(require('../Assets/Images/icAccelerationMid@3x.png')),
  icChevronUpRed: Image.resolveAssetSource(require('../Assets/Images/icChevronUpRed@3x.png')),
  ic_green_circle: Image.resolveAssetSource(require('../Assets/Images/ic_green_circle@3x.png')),
  ic_red_circle: Image.resolveAssetSource(require('../Assets/Images/ic_red_circle@3x.png')),
  ic_red_triangle: Image.resolveAssetSource(require('../Assets/Images/ic_red_triangle.png')),
  icSecurityRed: Image.resolveAssetSource(require('../Assets/Images/icSecurityRed@3x.png')),
  settings_dashboard_illustration: Image.resolveAssetSource(
    require('../Assets/Images/illustration@3x.png'),
  ),
  ic_mobile: Image.resolveAssetSource(require('../Assets/Images/icMobileWhite@3x.png')),
  payment: Image.resolveAssetSource(require('./../Assets/Images/payment@3x.png')),
  touch_screen: Image.resolveAssetSource(require('../Assets/Images/touch_screen@3x.png')),
  ic_account_settings_admin: Image.resolveAssetSource(
    require('../Assets/Images/account_settings_admin@3x.png'),
  ),
};

export default images;
